// extracted by mini-css-extract-plugin
module.exports = {"featuresWrapper":"SectionFeatures_featuresWrapper__14TbS","feature":"SectionFeatures_feature__2IdPs","title":"SectionFeatures_title__1sDgH"};